import React, { useEffect, useRef, useState } from "react";

import { Form } from "react-formio";
import axios from "axios";
import { API_URL } from "../../../Endpoints";
import { useDispatch, useSelector } from "react-redux";

import {
  buildIrScreenshotFileEntries,
  deleteUnmatchedKeys,
  displayImageOverLay,
  extractFileName,
  findAllKeys,
  getAllImages,
  getStoredIrScreenshotUrl,
} from "../utils/basic_utils";
import {
  getFormAutoFillMatches,
  mergeAutoFillIntoFormState,
  shouldUpdateFormAutoFill,
} from "../utils/form_auto_fill_utils";
import AlertDialog from "../../../Components/Dialog";
import { useLocation } from "react-router-dom";
import PreviousData from "../../../Components/previousDataButton";
import useMutationObserver from "../../../customHooks.js/useMutaitonObserver";
import useFormRequiredValidation from "../../../customHooks.js/useFormRequiredValidation";
import FormSubmitButton from "./FormSubmitButton";
import { captureIrScreenshot, save_annotations } from "../actions/dcm_actions";
import store from "../../../store";

let formDataReplica = {};
let UpdateForm = false;

let submitButtonClicked = false;

export default function QAForm(props) {
  const [formData, setFormData] = useState({});
  const [formDataLoading, setFormDataLoading] = useState(true);
  const dicom_data = useSelector((state) => state.dcm);
  const dispatch = useDispatch();

  const [respMessage, setRespMessage] = useState({
    error: false,
    message: "",
  });
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const formikRef = useRef(null);

  const [UpdatedSchema, setupdatedSchema] = useState({});

  // Helper function to generate the payload object from the selected file

  const rq = props.request_info;
  const handleButtonClick = () => {
    if (
      formData?.form_schema?.components?.filter(
        (obj) =>
          (obj?.components &&
            obj?.components.some(
              (component) => component?.key === "totalArea"
            )) ||
          obj?.key === "totalArea"
      )
    ) {
      setFormData((prevState) => ({
        ...prevState,
        response: {
          ...prevState.response,
          data: {
            ...prevState.response?.data,
            totalArea: dicom_data?.SelectedArea?.TotalArea, // Updating the value here
          },
        },
      }));
    }

    if (
      formData?.form_schema?.components?.filter(
        (obj) =>
          (obj?.components &&
            obj?.components.some(
              (component) => component?.key === "lesions_area"
            )) ||
          obj?.key === "lesions_area"
      )
    ) {
      setFormData((prevState) => ({
        ...prevState,
        response: {
          ...prevState.response,
          data: {
            ...prevState.response?.data,
            lesions_area:
              typeof dicom_data?.SelectedArea?.LisonsArea === "string"
                ? dicom_data.SelectedArea.LisonsArea.trim()
                : dicom_data?.SelectedArea?.LisonsArea || "",
          },
        },
      }));
    }
  };
  const updateAutoFilledFormValues = () => {
    const matches = getFormAutoFillMatches(
      formData?.form_schema?.components,
      dicom_data
    );

    if (
      shouldUpdateFormAutoFill(formData?.response?.data, matches)
    ) {
      setFormData((prevState) =>
        mergeAutoFillIntoFormState(prevState, matches, { dataPath: "response" })
      );
    }
  };

  useEffect(() => {
    updateAutoFilledFormValues();

    if (
      dicom_data.SelectedArea.TotalArea !==
        formData?.response?.data?.totalArea &&
      formData
    ) {
      handleButtonClick();
    }
  }, [
    dicom_data.SelectedArea,
    dicom_data?.mainScreenShotUrl,
    formData,
    dicom_data.etdrsActive,
    dicom_data?.lisonsAreasData,
    dicom_data?.etdrsVolumesFromSegmentationApi,
    dicom_data?.lisonOptions?.lisonAreaselected,
  ]);

  const loadInitialData = async () => {
    setFormDataLoading(true);

    await axios
      .get(
        `${API_URL}/api/v1/${
          props.request_info.role === "quality_control" ? "qc-form" : "qa-form"
        }?stack_id=${rq.stack_id}&user_id=${rq.user_id}${
          query.get("form_version_id")
            ? `&form_version_id=${query.get("form_version_id")}`
            : ""
        }`
      )
      .then((res) => {
        if (res?.data?.user_preferences?.oct_viewer_preferences) {
          dispatch({
            type: "UPDATE_USER_SETTINGS",
            settings: res.data.user_preferences.oct_viewer_preferences,
          });

          if (
            res?.data?.user_preferences?.oct_viewer_preferences
              ?.FluidSegmentation
          ) {
            dispatch({
              type: "UPDATE_LOCAL_SETTINGS",
              FluidSegmentation:
                res.data.user_preferences.oct_viewer_preferences
                  .FluidSegmentation,
            });
          }
        }
        UpdateForm = true;
        const index =
          res?.data?.form_schema?.components[0]?.components.findIndex(
            (component) => component.key === "leasions_area_img"
          );

        if (index !== -1) {
          // Store the removed component in state
          const [removed] =
            res?.data?.form_schema?.components[0]?.components.splice(index, 1);
        }
        let data = res.data;
        let moreModi = {
          ...data,
          form_schema: {
            ...data.form_schema,
            // components: componentsUpdated,
          },
        };

        setFormData(moreModi);
      })
      .catch((err) => {})
      .finally(() => {
        setFormDataLoading(false);
      });
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    const storedIrScreenshotUrl = getStoredIrScreenshotUrl(
      formData?.screenshot_urls
    );

    if (storedIrScreenshotUrl && dicom_data?.mainScreenShotUrl === null) {
      dispatch({
        type: "mainScreenShot_url_changed",
        mainScreenShotUrl: storedIrScreenshotUrl,
      });
    }
  }, [formData]);

  useMutationObserver(formData, setupdatedSchema, formDataReplica, UpdateForm);

  const activeFormComponents =
    UpdatedSchema?.components || formData?.form_schema?.components;
  const { isFormComplete, handleFormChange, handleFormRender, resolveMissingFields } =
    useFormRequiredValidation(
      activeFormComponents,
      formData?.response?.data,
      formikRef
    );

  const stackId = query.get("stack_id");
  const isDicomMissing =
    dicom_data.dicom_data[stackId]?.OP === null ||
    dicom_data.dicom_data[stackId]?.OPT === null;
  const hardDisabled = dicom_data?.submitDisable || isDicomMissing;
  const hardDisabledTooltip = isDicomMissing
    ? "Fundus and OCT images must be loaded before submitting."
    : dicom_data?.submitDisable
      ? "Submit is temporarily unavailable."
      : "";

  const handleExternalSubmit = () => {
    if (!isFormComplete || hardDisabled) {
      return;
    }

    if (formikRef.current) {
      submitButtonClicked = true;
      dispatch({ type: "LoadingOverlay_changed", LoadingOverlay: true });
      formikRef.current.props.onSubmit(formikRef.current.props.submission);
    }
  };

  const submit_form = async (e) => {
    if (query.get("role") !== "quality_control" && !submitButtonClicked) {
      return;
    }

    dispatch({ type: "LoadingOverlay_changed", LoadingOverlay: true });

    let filesNames, allUrlsOriginal, allUrls, deletedImagesUrls;
    const stackId = query.get("stack_id");
    const isGrader = query.get("role") === "grader";
    let submitScreenShotUrl = null;

    try {
      if (isGrader) {
        dispatch({
          type: "mainScreenShot_url_changed",
          mainScreenShotUrl: null,
        });

        submitScreenShotUrl = await captureIrScreenshot(
          store.getState().dcm,
          stackId,
          dispatch,
          { delayMs: 0 },
        );
      }

      if (query.get("role") !== "quality_control") {
        const dropZoneFiles = getAllImages(
          UpdatedSchema?.components
            ? UpdatedSchema.components
            : formData?.form_schema?.components,
        );

        filesNames = { ...dropZoneFiles };
        if (formData?.screenshot_urls) {
          allUrlsOriginal = Object.values(formData?.screenshot_urls).flat();
        }

        allUrls = Object.values(dropZoneFiles).flat();

        deletedImagesUrls = allUrlsOriginal.filter(
          (url) => !allUrls.includes(url),
        );

        Object.keys(filesNames).forEach((key) => {
          filesNames[key] = filesNames[key].map(extractFileName);
        });

        const screenShotUrlForSubmit = isGrader
          ? submitScreenShotUrl
          : dicom_data?.mainScreenShotUrl;
        if (screenShotUrlForSubmit) {
          allUrls.push(screenShotUrlForSubmit);
        }
      }

      const screenShotUrlForFiles = isGrader
        ? submitScreenShotUrl
        : dicom_data?.mainScreenShotUrl;
      const irScreenshotFiles = buildIrScreenshotFileEntries(
        screenShotUrlForFiles,
        UpdatedSchema?.components
          ? UpdatedSchema.components
          : formData?.form_schema?.components,
      );

      if (e.files) {
        e.files = {
          ...e.files,
          ...filesNames,
          ...irScreenshotFiles,
        };
      } else {
        e["files"] = {
          ...filesNames,
          ...irScreenshotFiles,
        };
      }
      if (!screenShotUrlForFiles) {
        delete e?.data?.totalArea;
        delete e?.data?.lesions_area;
      }

      const formSchemaKeys = findAllKeys(formData?.form_schema?.components);

      deleteUnmatchedKeys(e.data, formSchemaKeys);

      if (isGrader) {
        try {
          await save_annotations(
            store.getState().dcm,
            stackId,
            query.get("user_id"),
            query.get("series_no"),
            query.get("role"),
            query.get("form_version_id") ? "additional_form" : "primary_form",
            query.get("form_version_id") ? query.get("form_version_id") : "",
          );
        } catch (saveErr) {
          console.error("Save annotations failed:", saveErr);
          setRespMessage({
            error: true,
            message: "Unable to save annotations",
          });
          return;
        }
      }

      await axios.post(
        `${API_URL}/api/v1/${
          props.request_info.role === "quality_control" ? "qc-form" : "qa-form"
        }`,
        {
          stack_id: rq.stack_id,
          user_uuid: rq.user_id,
          responses: e,
          form_type: query.get("form_version_id")
            ? "additional_form"
            : "primary_form",
          form_version_id: formData.form_version_id,
          screenshot_urls: allUrls,
          deleted_screenshot_urls: deletedImagesUrls,
          status: "completed",
          disclaimer: false,
        },
      );

      setRespMessage({ error: false, message: "Data saved successfully" });
    } catch (err) {
      console.error("QA form submit failed:", err);
      setRespMessage({ error: true, message: "Unable to save data" });
    } finally {
      dispatch({ type: "LoadingOverlay_changed", LoadingOverlay: false });
      submitButtonClicked = false;
    }
  };

  if (formDataLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center", // Added to center vertically
          height: "100%", // Added to center vertically
        }}
      >
        <h3>Loading...</h3>
      </div>
    );
  }
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "0px 10px",
        overflow: "auto",
        height: "100%",
      }}
    >
      {formData?.previous_visit_data?.previous_record?.data ? (
        <PreviousData formData={formData} />
      ) : null}

      {respMessage.message !== "" ? (
        <AlertDialog
          open={respMessage.message === "" ? false : true}
          handleClose={() => {
            setRespMessage({ error: false, message: "" });
          }}
          message={respMessage.message}
          error={respMessage.error}
        />
      ) : null}
      {formData?.form_schema && (
        <Form
          key={UpdatedSchema ? "updated" : "initial"}
          form={
            UpdatedSchema?.components ? UpdatedSchema : formData.form_schema
          }
          submission={formData.response}
          onSubmit={submit_form}
          onChange={handleFormChange}
          onRender={handleFormRender}
          ref={formikRef}
          options={{
            noDefaultSubmitButton: true, // This prevents default form submission
            hooks: {
              beforeSubmit: function (submission, callback) {
                callback(null, submission); // Manually handle form submission
              },
            },
          }}
        ></Form>
      )}
      {formData ? (
        <>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "45px",
              height: "300px",
            }}
          >
            {dicom_data?.mainScreenShotUrl ? (
              <img
                style={{ cursor: "pointer" }}
                onClick={() => {
                  displayImageOverLay(dicom_data?.mainScreenShotUrl, dispatch);
                }}
                src={dicom_data?.mainScreenShotUrl}
                alt="ScreenShot"
                height="200px"
                width="200px"
              />
            ) : null}

            <FormSubmitButton
              label="Submit"
              formRef={formikRef}
              resolveMissingFields={resolveMissingFields}
              hardDisabled={hardDisabled}
              hardDisabledTooltip={hardDisabledTooltip}
              onSubmit={handleExternalSubmit}
            />
          </div>
        </>
      ) : (
        <div>Unable to load form</div>
      )}

      {respMessage.message !== "" && <div>{respMessage.message}</div>}
    </div>
  );
}
